import * as yup from 'yup';

import {
    validateBillToAddr,
    validateBillToCity,
    validateEmail,
    validateName,
    validatePhoneNbr,
    validateShipToAddr,
    validateShipToCity,
    validateShipToZipUSandCA,
} from '../../tools/yup-validators.functions';

export const contactInfoModalValidation = yup.object({
    billToAddr1: validateBillToAddr(`billToEmail`),
    billToAddr2: validateBillToAddr(`billToEmail`),
    billToCity: validateBillToCity(),
    billToEmail: validateEmail(),
    billToName: validateName(),
    billToPhone: validatePhoneNbr(),
    billToState: yup.string().label(`Billing State`),
    billToZip: validateShipToZipUSandCA(),
    contactEmail: validateEmail(),
    contactName: validateName(),
    contactPhone: validatePhoneNbr(),
    shipToAddr1: validateShipToAddr(`shipToEmail`),
    shipToAddr2: validateShipToAddr(`shipToEmail`),
    shipToCity: validateShipToCity(),
    shipToEmail: validateEmail(),
    shipToName: validateName(),
    shipToPhone: validatePhoneNbr(),
    shipToState: yup.string().label(`Shipping State`),
    shipToZip: validateShipToZipUSandCA(),
});
